/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ai_BudgetInputs */

const en_ai_budget = /** @type {(inputs: Ai_BudgetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monthly budget (USD)`)
};

const de_ai_budget = /** @type {(inputs: Ai_BudgetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monatsbudget (USD)`)
};

/**
* | output |
* | --- |
* | "Monthly budget (USD)" |
*
* @param {Ai_BudgetInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ai_budget = /** @type {((inputs?: Ai_BudgetInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ai_BudgetInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_ai_budget(inputs)
	return en_ai_budget(inputs)
});